import Typography from "aldoo-ra/Typography"

const QuoteText = ({ text, quoteUp, quoteDown }) => {
  return (
    <div className="relative flex w-full md:max-w-[460px] lg:max-w-[690px] justify-center items-center pt-12 pl-6 md:pt-8">
      {/* Left Quote */}
      <span className="absolute top-0 left-8 md:left-0 text-[30px] md:text-[40px] text-primary transform -translate-y-2 -translate-x-4">
        {quoteUp || "“"}
      </span>
      {/* Text Content */}
      <Typography variant="h2" className="text-text text-left leading-relaxed">
        {text}
      </Typography>
      {/* Right Quote */}
      <span className="absolute bottom-[-24px] right-0 text-5xl text-primary transform translate-y-2">
        {quoteDown || "”"}
      </span>
    </div>
  )
}

export default QuoteText
